module.exports = __webpack_public_path__ + "static/media/offer_badge.496a8ffa.png";